<template>
    <div class="page">
        <!-- 群聊 -->
        <div class="step" v-if="scene == 1">
            <div class="class" @click="showGroupId++">
                <div class="dfsb">
                    <div>
                        <div style="margin-bottom: 4px;">
                            状态：
                            <span :class="{ 'red': groupInfo.bindText != '已绑定' }">{{ groupInfo.bindText }}</span>
                        </div>
                        <div style="margin-bottom: 4px;">
                            绑定： {{ groupInfo.className || groupInfo.schoolName }}
                        </div>
                        <div>
                            群名：
                            <span :class="{ 'red': !groupInfo.chatName }">{{ groupInfo.chatName }}</span>
                        </div>
                    </div>
                </div>
                <div style="margin: 10px 0 0 72px;">
                    <a-button type="primary" @click="bindGroup()">重新绑定</a-button>
                </div>
                <div class="mt-8 red" v-if="errorMsg">{{ errorMsg }}</div>
            </div>
            <!-- 显示群Id -->
            <div v-if="showGroupId >= 10">
                <div class="group-id">{{ groupId }}</div>
            </div>
            <div class="step-box">
                <div class="step-title">更多的设置与建议：</div>
                <div class="suggestion">
                    <div class="line"></div>
                    <div class="df">
                        <div class="round">1</div>
                        <div class="title">建议更改群的基本设置</div>
                    </div>
                    <div class="pic">
                        <div class="mt-8">群管理的设置，建议做如下配置。</div>
                        <div class="mb-12">同时做好群公告与欢迎语。</div>
                        <img src="https://static.khsdb.com/oper/suggestion.png" @click="preview(1)">
                    </div>
                </div>
                <div class="suggestion">
                    <div class="line"></div>
                    <div class="df">
                        <div class="round">2</div>
                        <div class="title">{{ showUpload ? '上传' : '下载' }}进群二维码</div>
                    </div>
                    <div class="pic" v-if="!showUpload">
                        <div class="mt-8">可转发以下二维码给家长，或其他相关人员扫码进群。</div>
                        <div><span class="red">注意：二维码需要使用微信扫描</span>（非企业微信）</div>
                        <div class="mb-12 grey-text">如果无法保存到相册，请长按图片保存</div>
                        <div class="qrcode">
                            <img :src="groupInfo.qrcode" @click="preview(3)">
                        </div>
                        <div class="btn">
                            <a-button @click="downloadImage">保存到相册</a-button>
                        </div>
                        <div v-if="groupInfo.expireTime">
                            <div class="date-text">本二维码{{ groupInfo.expireTime }}过期</div>
                            <div class="btn">
                                <a-button @click="reUpload">重新上传</a-button>
                            </div>
                        </div>
                    </div>
                    <div v-else class="upload">
                        <div class="mt-8">请从群详情，<a @click="preview(2)">群二维码名片</a>保存到相册，然后上传，同时需填写二维码有效期，二维码有效期通常为7天内有效。
                        </div>
                        <a-upload list-type="picture-card" class="uploader" :before-upload="beforeUpload"
                            :customRequest="uploadFile">
                            <img v-if="imageUrl" :src="imageUrl" alt="avatar" />
                            <div v-else>
                                <a-icon :type="loading ? 'loading' : 'plus'" />
                                <div class="ant-upload-text">
                                    上传
                                </div>
                            </div>
                        </a-upload>
                        <div style="margin-bottom: 10px;">在此日期之前有效：</div>
                        <a-date-picker @change="dateChange" :disabledDate="disabledDate" :showToday="false"
                            :inputReadOnly="true" style="width: 200px;margin-bottom: 2px;" v-model="qrcodeExpire" />
                        <div class="btn">
                            <a-button @click="saveQrcode" style="width: 200px;">保存群二维码</a-button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- 工作台 -->
        <div v-if="scene == 2">
            <div class="box" @click="testBtn">
                WebSocket连接状态: <span :class="{ green: isConnected }">{{ isConnected ? '已连接' : '未连接' }}</span>
            </div>
            <div class="df box jcsb">
                <div>
                    每<a-input-number v-model="pollingTime" type="number" @change="changePollingTime" :min="1" :max="60"
                        style="width: 60px;" :precision="0"></a-input-number>分钟间隔抓取推送数据
                </div>
                <div class="push-status">
                    <div class="w100" :class="{ 'green': pushStatus, 'red': !pushStatus }">
                        {{ pushStatus ? '推送进行中' : '推送停止' }}
                    </div>
                    <div class="btn">
                        <a-button @click="changePushStatus">
                            <template v-if="pushStatus"><a-icon type="pause-circle" />停止</template>
                            <template v-if="!pushStatus"><a-icon type="play-circle" />开始</template>
                        </a-button>
                    </div>
                </div>
            </div>
            <div class="df box mb-10 jcsb" style="padding-top: 0;">
                <div>
                    每天<a-time-picker v-model="updateTime" format="HH:mm" style="width: 110px;"
                        :allowClear="false" />更新失效的群二维码
                </div>
                <div class="push-status">
                    <div class="w100" :class="{ 'green': updateStatus, 'red': !updateStatus }">
                        {{ updateStatus ? '更新进行中' : '更新停止' }}
                    </div>
                    <div class="btn">
                        <a-button @click="changeUpdateStatus">
                            <template v-if="updateStatus"><a-icon type="pause-circle" />停止</template>
                            <template v-if="!updateStatus"><a-icon type="play-circle" />开始</template>
                        </a-button>
                    </div>
                </div>
            </div>
            <!-- 打开群聊 -->
            <div class="box mb-10">
                <div class="df">
                    <a-input placeholder="请输入群ID" v-model="targetGroupId"></a-input>
                    <a-button style="width: 100px;margin-left: 12px;" @click="openGroup()">打开群聊</a-button>
                </div>
            </div>
            <!-- 分享链接 -->
            <div class="mt-20 box" style="padding-bottom: 5px;">
                <h4>分享链接</h4>
                <div class="mb-10 df">
                    <div class="label">消息标题:</div>
                    <a-input placeholder="请输入消息标题" v-model="shareTitle"></a-input>
                </div>
                <div class="mb-10 df">
                    <div class="label">消息描述:</div>
                    <a-input placeholder="请输入消息描述" v-model="shareDesc"></a-input>
                </div>
                <div class="oper-btns">
                    <a-button @click="messageTest('group')">分享链接到群聊</a-button>
                </div>
            </div>
            <!-- 数据统计 -->
            <div class="count-box">
                <div>
                    今日总课节数： {{ todayClassCount }}
                    <span style="margin-left: 36px;">已关联群个数： {{ groupCount }}</span>
                </div>
                <div>今日已推送课节通知： {{ todayClassPushCount }}</div>
                <div class="mb-12">今日已推送教师评价： {{ todayEvaluationPushCount }}</div>
                <div>页面开启时间：{{ openPageTime }}</div>
                <div>累计推送课节通知： {{ totalClassPushCount }}</div>
                <div>累计推送教师评价： {{ totalEvaluationPushCount }}</div>
                <div>【刷新页面累计推送数会重置为0】</div>
            </div>
            <!-- 日志 -->
            <div style="margin: 20px 16px;">
                <p>
                    <a-button @click="showLog = !showLog">日志</a-button>
                    <a-button v-if="logText != ''" @click="logText = ''" style="margin-left: 12px;">清除</a-button>
                </p>
                <textarea v-show="showLog" class="log-box" v-model="logText" ref="logTextRef"></textarea>
            </div>
        </div>
        <!-- 图片预览 -->
        <previewImg v-if="showPreview" @closePreview="closePreview" :img="previewUrl" :showDownload="false"
            :closeAble="true">
        </previewImg>
    </div>
</template>

<script>
import dayjs from 'dayjs';
import qywx from '../../api/third-qywx';
import user from '../../api/user';
import previewImg from '../../components/previewImg/previewImg.vue'
import moment from 'moment';
import OSS from 'ali-oss'
import { v1 as uuidv1 } from 'uuid'
import websocketService from '../../utils/webSocket'
const jsApiList = [
    'getCurExternalChat',
    'getContext',
    'openSingleChat',
    'openExistedChatWithMsg',
    'openEnterpriseChat',
    'sendChatMessage'
]
export default {
    name: "ClassAssistant",
    data() {
        return {
            isScriptsLoaded: false, // 标记脚本是否加载完成
            scene: 0, // 1群聊助手 2工作台
            pushStatus: true, // true开启 false关闭
            updateStatus: true, // true开启 false关闭
            showGroupId: 0,
            qrCodeUrl: '',
            groupInfo: {},
            groupId: '', // 当前群Id
            showLog: true,
            logText: '', // 日志内容
            SceneValue: '', // 打开场景
            timer: null, // 定时器
            timeout: null, // 整分钟定时器
            updateTimer: null, // 更新二维码定时器
            timeout2: null, // 更新群二维码整分钟定时器
            updateingFlag: false, // 正在更新二维码
            pollingFlag: false, // 正在推送通知
            pollingTime: 10,
            updateTime: moment('00:30', 'HH:mm'),
            isChanging: false, // 轮询时间防抖
            requesting: false,
            checkGroupId: 'c0a461365b55476f8d6b9729efd34ff9', // 后端接口配置
            checkUploadKey: 'c0a29efd46535547bf86613d96b974ff', // oss上传安全校验的key
            errorMsg: '',
            lastResetDate: null, // 最后一次重置时间
            openPageTime: '', // 页面启动时间
            todayClassCount: 0, // 今日总课节数
            groupCount: 0, // 关联群个数
            todayClassPushCount: 0, // 今日推送课节数
            todayEvaluationPushCount: 0, // 今日推送评价数
            totalClassPushCount: 0, // 累计推送课节数
            totalEvaluationPushCount: 0, // 累计推送评价数
            agentId: 0,
            corpId: '', // 企业ID
            showPreview: false,
            previewUrl: '',
            showUpload: false,
            imageUrl: '',
            loading: false,
            qrcodeExpire: '',
            ossToken: {},
            targetGroupId: '',
            shareTitle: '',
            shareDesc: '',
            shareUrl: 'https://jiaoyuju.khsdb.com',  // h5课程详情链接
            isConnected: false,
            wsList: [], // websocket更新群二维码队列
            isProcessing: false, // 正在进行实时更新wb队列
        };
    },
    components: {
        previewImg
    },
    created() {
        this.initCounter();
        this.qrcodeExpire = moment().add(7, 'days').endOf('day')
        // this.groupId = 'wrt_TYDgAApfjMzz0zL_YoCEW8znBpxw'
        // this.getGroupInfo()
        // this.pollingUpdateQrcode()
        // this.getPushMessage()
    },
    mounted() {
        this.openPageTime = dayjs(new Date()).format('YYYY-MM-DD HH:mm:ss')
        this.loadSDK();
        this.handleUpdateTimer()
    },
    beforeDestroy() {
        this.stopPolling()
        // 组件销毁前断开连接
        websocketService.disconnect()
        this.$eventBus.$off('ws-connected')
    },
    watch: {
        todayClassPushCount(newVal) {
            localStorage.setItem('todayClassPushCount', newVal);
        },
        todayEvaluationPushCount(newVal) {
            localStorage.setItem('todayEvaluationPushCount', newVal);
        },
        updateingFlag: {
            handler() {
                // console.log('更新二维码变化')
                this.checkBothFalse()
            },
            immediate: true
        },
        pollingFlag: {
            handler() {
                // console.log('更新推送变化')
                this.checkBothFalse()
            },
            immediate: true
        }
    },
    methods: {
        testBtn() {
            // 调用了才能收到通知
            // qywx.testWs()
        },
        moment,
        // 打印页面日志
        output(msg, type = '') {
            let now = dayjs(new Date()).format('YYYY-MM-DD HH:mm:ss')
            const formattedMsg = typeof msg === 'string' ? msg : JSON.stringify(msg, null, 2)
            this.logText = `${this.logText}${now} ${type}\n${formattedMsg}\n`
            this.$nextTick(() => {
                const textarea = this.$refs.logTextRef;
                if (textarea) {
                    textarea.scrollTop = textarea.scrollHeight;
                }
            })
        },
        // 加载v2企业微信SDK
        loadSDK() {
            const script = document.createElement('script');
            script.src = 'https://wwcdn.weixin.qq.com/node/open/js/wecom-jssdk-2.0.2.js'; //v2
            script.onload = () => {
                this.getSignature()
            };
            document.body.appendChild(script);
        },
        // 获取签名
        getSignature() {
            // const isInWeCom = /wxwork/i.test(navigator.userAgent);
            // this.output(isInWeCom, '是否在企业微信中');
            // this.output(process.env.NODE_ENV, '当前环境')
            let scriptUrls = []
            if (process.env.NODE_ENV == 'production') {
                scriptUrls = [
                    'https://3rd.khsdb.com/qyweixin/getJsApiSign/qywx',
                    'https://3rd.khsdb.com/qyweixin/getAppJsApiSign/app'
                ];
                this.agentId = 1000008
                this.corpId = 'wwa505cd078e81c088'
            } else {
                scriptUrls = [
                    'https://3rd-test.khsdb.com/qyweixin/getJsApiSign/qywx',
                    'https://3rd-test.khsdb.com/qyweixin/getAppJsApiSign/app'
                ];
                this.agentId = 1000002
                this.corpId = 'wwb136882612d74d2b'
            }
            const loadScript = (url) => {
                return new Promise((resolve, reject) => {
                    const script = document.createElement('script');
                    script.src = url;
                    script.onload = resolve;
                    script.onerror = reject;
                    document.body.appendChild(script);
                });
            };

            Promise.all(scriptUrls.map(loadScript))
                .then(() => {
                    // 上面2个脚本会在window中挂在idapp和idqywx2个对象，包含签名等信息
                    // this.output('脚本加载完成')
                    this.initWeixinSDK()
                })
                .catch((error) => {
                    this.output(error, '脚本加载失败')
                });
        },
        // 初始化企业微信 SDK
        initWeixinSDK() {
            // this.output('开始初始化')
            ww.register({
                corpId: this.corpId, // 必填，当前用户企业所属企业ID
                agentId: this.agentId, // 必填，当前应用的AgentID
                jsApiList, // 必填，需要使用的JSAPI列表
                getConfigSignature: this.getConfigSignature, // 必填，根据url生成企业签名的回调函数
                getAgentConfigSignature: this.getAgentConfigSignature, // 必填，根据url生成应用签名的回调函数
            })
            this.getScene()
        },
        getConfigSignature() {
            let timestamp = window.idqywx.timestamp
            let nonceStr = window.idqywx.nonce
            let signature = window.idqywx.signature
            // this.output(window.idqywx, 'idqywx')
            return { timestamp, nonceStr, signature }
        },
        getAgentConfigSignature() {
            let timestamp = window.idapp.timestamp
            let nonceStr = window.idapp.nonce
            let signature = window.idapp.signature
            // this.output(window.idapp, 'idapp')
            return { timestamp, nonceStr, signature }
        },
        // 获取场景值
        getScene() {
            ww.getContext({
                success: (res) => {
                    // this.output(res, '获取场景值成功')
                    this.SceneValue = res.entry
                    this.scene = res.entry == 'group_chat_tools' ? 1 : res.entry == 'normal' ? 2 : 0
                    // 如果是群聊，获取群聊id，并调接口获取群信息
                    if (this.scene == 1) {
                        this.getGroupId()
                    }
                    // 如果是工作台，开始定时器轮询
                    if (this.scene == 2) {
                        this.polling()
                        // 在组件挂载时连接WebSocket
                        this.initWebSocket()
                        this.$eventBus.$on('ws-connected', (status) => {
                            this.isConnected = status
                        })
                    }
                },
                fail: (err) => {
                    this.output(err, '获取场景值失败');
                }
            })
        },
        // 获取群ID
        getGroupId() {
            ww.getCurExternalChat({
                success: (res) => {
                    this.groupId = res.chatId;
                    // 用群ID调接口获取群信息
                    this.getGroupInfo()
                },
                fail: (err) => {
                    this.output(err, '获取群ID失败');
                }
            })
        },
        getGroupInfo(upload) {
            let params = {
                chatId: this.groupId,
                checkGroupId: this.checkGroupId
            }
            if (upload) {
                params.upload = true
            }
            qywx.groupInspection(params).then(res => {
                this.groupInfo.bindText = res.bindFlag == 0 ? '未绑定' : res.bindFlag == 1 ? '已绑定' : '已绑定班级ID不匹配'
                this.groupInfo.chatName = res.chatName
                if (res.className) {
                    this.groupInfo.className = res.bindFlag == 0 ? '无' : res.className + '(' + res.classId + ')'
                } else {
                    this.groupInfo.className = ''
                }
                if (res.schoolName) this.groupInfo.schoolName = res.schoolName
                this.groupInfo.qrcode = res.qrcode ? res.qrcode : ''
                this.groupInfo.expireTime = res.qrCodeExpire ? dayjs(res.qrCodeExpire).format('YYYY-MM-DD') : ''
                this.errorMsg = res.errorMsg ? res.errorMsg : ''
                this.ossToken = res.stsToken || {}
                if (upload) {
                    this.showUpload = true
                } else {
                    let flag = res.qrCodeExpire ? dayjs(res.qrCodeExpire).isAfter(dayjs(), 'day') : true
                    this.showUpload = flag && res.qrcode ? false : true
                }
                this.$forceUpdate()
            })
        },
        bindGroup() {
            let params = {
                chatId: this.groupId,
                checkGroupId: this.checkGroupId
            }
            qywx.bindClassChat(params).then(res => {
                this.groupInfo.bindText = res.ifBind ? '已绑定' : '未绑定'
                if (res.className) {
                    this.groupInfo.className = res.ifBind ? res.className + '(' + res.classId + ')' : '无'
                } else {
                    this.groupInfo.className = ''
                }
                if (res.schoolName) this.groupInfo.schoolName = res.schoolName
                this.groupInfo.chatName = res.chatName
                this.groupInfo.qrcode = res.qrcode ? res.qrcode : ''
                this.errorMsg = res.errorMsg ? res.errorMsg : ''
                this.$forceUpdate()
            })
        },
        initCounter() {
            const today = new Date().toDateString();
            const lastReset = localStorage.getItem('lastResetDate');
            // 如果上次重置日期不是今天，则重置计数器
            if (lastReset !== today) {
                this.todayClassPushCount = 0;
                this.todayEvaluationPushCount = 0;
                localStorage.setItem('lastResetDate', today);
                localStorage.setItem('todayClassPushCount', 0);
                localStorage.setItem('todayEvaluationPushCount', 0);
            } else {
                // 否则从本地存储恢复计数
                const classCount = localStorage.getItem('todayClassPushCount');
                const evaluationCount = localStorage.getItem('todayEvaluationPushCount');
                this.todayClassPushCount = classCount ? parseInt(classCount) : 0;
                this.todayEvaluationPushCount = evaluationCount ? parseInt(evaluationCount) : 0;
            }
            // 设置定时器检查日期变化
            setInterval(this.checkDateChange, 60000);
        },
        checkDateChange() {
            const today = new Date().toDateString();
            const lastReset = localStorage.getItem('lastResetDate');
            if (lastReset !== today) {
                this.output('重置今日数据')
                this.todayClassPushCount = 0;
                this.todayEvaluationPushCount = 0;
                localStorage.setItem('lastResetDate', today);
                localStorage.setItem('todayClassPushCount', 0);
                localStorage.setItem('todayEvaluationPushCount', 0);
            }
        },
        changePollingTime() {
            if (this.isChanging) return;
            this.isChanging = true;
            setTimeout(() => {
                if (!this.pollingTime) this.pollingTime = 1
                this.output(this.pollingTime, '当前轮询时间')
                this.stopPolling()
                this.polling()
                this.isChanging = false
            }, 500)
        },
        changeUpdateStatus() {
            this.updateStatus = !this.updateStatus;
            if (this.updateStatus) {
                this.output('更新群二维码进行中')
                this.handleUpdateTimer()
            } else {
                this.output('停止更新群二维码')
                this.stopUpdatePolling()
            }
        },
        stopUpdatePolling() {
            this.updateingFlag = false
            clearInterval(this.updateTimer)
            clearTimeout(this.timeout2)
            this.updateTimer = null
            this.timeout2 = null
        },
        // 处理更新群二维码计时器
        handleUpdateTimer() {
            clearInterval(this.updateTimer)
            // 计算到下一个整分钟的时间
            const currentSeconds = new Date().getSeconds();
            const delayTime = (60 - currentSeconds) * 1000;
            // 下个整分钟开始执行轮询
            this.timeout2 = setTimeout(() => {
                this.updateTimer = setInterval(() => {
                    if (dayjs().format('HH:mm') == dayjs(this.updateTime).format('HH:mm')) {
                        this.output('更新群二维码开始')
                        // 当前时间为更新时间，正在更新中的标识变为true，暂停推送轮询，结束后再次开启推送的计时器
                        this.updateingFlag = true
                        this.pollingUpdateQrcode()
                    }
                }, 1000 * 60)
            }, delayTime)
        },
        // 轮询更新群二维码
        pollingUpdateQrcode() {
            // 查询拿到群ID
            qywx.getUpdateGroupIds({ checkGroupId: this.checkGroupId }).then(res => {
                if (res.length) {
                    this.output('更新群二维码中，暂停推送轮询')
                    this.stopPolling()
                    this.processUpdateQrcode(res)
                } else {
                    this.updateingFlag = false
                }
            })
        },
        // 递归来进入群聊执行更新二维码的java进程
        processUpdateQrcode(arr, index = 0) {
            if (!this.updateStatus) return
            if (index >= arr.length) {
                // 更新完毕的时候恢复推送轮询
                this.updateingFlag = false
                this.output('继续轮询')
                this.polling()
                return
            }
            const item = arr[index];
            this.handleUpdate(item, () => {
                // 当前消息处理完成后，递归处理下一个
                this.processUpdateQrcode(arr, index + 1);
            });
        },
        handleUpdate(item, callback) {
            this.output(item, 'saveQr')
            ww.openEnterpriseChat({
                chatId: item,
                success: (res) => {
                    this.output(item, '打开群聊')
                    const xhr = new XMLHttpRequest();
                    xhr.open("GET", "https://beta-operation-api.khsdb.com:8443/qyweixin/saveQR?chatId=" + encodeURIComponent(item) + '&type=1&key=' + this.checkUploadKey, true);
                    xhr.onload = () => {
                        // this.output("xhr.onload");
                    };
                    xhr.onreadystatechange = () => {
                        if (xhr.readyState === XMLHttpRequest.DONE) {
                            if (xhr.status === 200) {
                                this.output(xhr.responseText, '调用更新二维码接口');
                                callback()
                            } else {
                                this.output(xhr.status, '调用更新二维码接口失败，状态码为');
                                callback()
                            }
                        }
                    };
                    xhr.onerror = (err) => {
                        this.output(err, '调用更新二维码接口失败');
                        callback()
                    };
                    xhr.ontimeout = () => {
                        this.output(xhr.status, '调用更新二维码接口超时，状态码为');
                        callback()
                    };
                    xhr.send(null);
                },
                fail: (err) => {
                    this.output(err, '打开群聊失败:' + item);
                    callback()
                }
            })
        },
        getTodayCount() {
            qywx.getTodayCount().then(res => {
                this.todayClassCount = res.totalSchedule
                this.groupCount = res.totalChat
            })
        },
        // 递归来依次点击发送
        processMessages(arr, index = 0) {
            // 如果在更新二维码中则停止
            if (this.updateingFlag || !this.pushStatus) return
            if (index >= arr.length) return this.pollingFlag = false
            this.pollingFlag = true
            const item = arr[index];
            this.messageTo(item, () => {
                // 当前消息处理完成后，递归处理下一个
                this.processMessages(arr, index + 1);
            });
        },
        // 分享链接
        messageTo(item, callback) {
            let temp = item.type == 1 ? '上课提醒' : item.type == 2 ? '课后总结' : item.subject + '运营详情'
            let title = item.type == 3 ? temp : temp + '(' + item.className + ')'
            const xhr = new XMLHttpRequest();
            xhr.open("GET", "https://beta-operation-api.khsdb.com:8443/qyweixin/clickSend?title=" + encodeURIComponent(title), true);
            xhr.onload = () => {
                // this.output("xhr.onload");
            };
            xhr.onreadystatechange = () => {
                if (xhr.readyState === XMLHttpRequest.DONE) {
                    if (xhr.status === 200) {
                        this.output(xhr.responseText, item.chatId + '调用clickSend接口');
                    } else {
                        this.output(xhr.status, item.chatId + '调用clickSend接口失败，状态码为');
                    }
                }
            };
            xhr.onerror = (err) => {
                this.output(err, item.chatId + '调用clickSend接口失败');
            };
            xhr.ontimeout = () => {
                this.output(xhr.status, item.chatId + '调用clickSend接口超时，状态码为');
            };
            xhr.send(null);
            let imgUrl = ''
            if (item.type == 3) {
                imgUrl = item.evaluationLevel == 1 ? 'https://khsdb.com/oper/good.png' : item.evaluationLevel == 1 ? 'https://khsdb.com/oper/general.png' : 'https://khsdb.com/oper/bad.png'
            } else {
                imgUrl = item.type == 1 ? 'https://khsdb.com/oper/remind.png' : 'https://khsdb.com/oper/summarize.png'
            }
            ww.openExistedChatWithMsg({
                chatId: item.chatId,
                msg: {
                    msgtype: 'link',
                    link: {
                        title: title,
                        desc: item.notice,
                        url: item.path,
                        imgUrl
                    }
                },
                success: (res) => {
                    // this.output('分享链接成功')
                    if (item.type == 1) {
                        this.todayClassPushCount++
                        this.totalClassPushCount++
                    } else {
                        this.todayEvaluationPushCount++
                        this.totalEvaluationPushCount++
                    }
                    let key = item.type == 3 ? item.path.match(/secret=([\w-]+)(&|$)/)[1] : item.path.match(/key=([\w-]+)(&|$)/)[1]
                    let ts = item.path.match(/[&?]ts=([^&]+)#/) ? item.path.match(/[&?]ts=([^&]+)#/)[1] : null
                    if (ts) item.ts = ts
                    delete item.appId;
                    delete item.notice;
                    delete item.path;
                    this.pushMessageLog(key, item)
                    callback();
                },
                fail: (err) => {
                    this.output(err, '分享链接失败');
                    if (err.err_msg == 'openExistedChatWithMsg:fail_invalid_chat_id') {
                        this.output('执行删除失效群')
                        qywx.deleteClassChatGroup({ chatId: item.chatId }).then(res => {
                            this.output(res, '删除失效群成功')
                        })
                    }
                    callback();
                },
                cancel: () => {
                    this.output('取消分享链接');
                    callback();
                },
            })
        },
        // 轮询调用请求
        polling() {
            this.output('推送进行中')
            // 计算到下一个整分钟的时间
            const currentSeconds = new Date().getSeconds();
            const delayTime = (60 - currentSeconds) * 1000;
            // 下个整分钟开始执行轮询
            this.timeout = setTimeout(() => {
                this.getTodayCount()
                this.getPushMessage()
                this.timer = setInterval(() => {
                    // 检查当前分钟数是否能被pollingTime整除
                    const currentMinute = new Date().getMinutes();
                    if (currentMinute % this.pollingTime === 0) {
                        this.output('正在轮询');
                        this.getTodayCount();
                        this.getPushMessage();
                    }
                }, 60000)
            }, delayTime)

        },
        getPushMessage() {
            if (this.requesting) return
            this.requesting = true
            qywx.getPushMessage().then(res => {
                if (res.length) {
                    this.processMessages(res)
                }
            }).catch(err => {
                this.output(err, '获取推送列表失败')
            }).finally(() => {
                this.requesting = false
            })
        },
        pushMessageLog(key, params) {
            qywx.pushMessageLog(key, params).then(() => {
                let id = params.type == 3 ? 'S' + params.schoolId : params.scheduleId
                this.output(id, '日志保存成功')
            }).catch(err => {
                this.output(err, '日志保存失败')
            })
        },
        // 保存二维码
        downloadImage() {
            let params = {
                qrcode: this.groupInfo.qrcode,
                name: this.groupInfo.chatName || ''
            }
            qywx.downloadChatQrcode(params).then(res => {
                const blob = new Blob([res.data], { type: 'image/png' });
                const url = URL.createObjectURL(blob);

                const link = document.createElement('a');
                link.href = url;
                link.download = this.groupInfo.chatName + '群二维码';
                document.body.appendChild(link);
                link.click();

                setTimeout(() => {
                    document.body.removeChild(link);
                    URL.revokeObjectURL(url);
                }, 100);
            })
        },
        changePushStatus() {
            this.pushStatus = !this.pushStatus;
            if (this.pushStatus) {
                this.polling()
            } else {
                this.output('停止推送')
                this.stopPolling()
            }
        },
        stopPolling() {
            clearInterval(this.timer)
            clearTimeout(this.timeout)
            this.timer = null
            this.timeout = null
            this.pollingFlag = false
        },
        preview(type) {
            this.showPreview = true
            if (type == 1) {
                this.previewUrl = 'https://static.khsdb.com/oper/suggestion.png'
            } else if (type == 2) {
                this.previewUrl = 'https://static.khsdb.com/oper/groupQrcode.png'
            } else {
                this.previewUrl = this.groupInfo.qrcode
            }
        },
        closePreview() {
            this.showPreview = false
        },
        // 日期选择范围
        disabledDate(current) {
            if (!current) return false;

            // 获取今天日期并设置时间为0:00:00
            const today = moment().endOf('day')
            // 计算7天后的日期
            const sevenDaysLater = moment().add(7, 'days').endOf('day');

            // 禁用今天和7天后的日期
            return current < today || current > sevenDaysLater;
        },
        dateChange(date, dateString) {
            this.qrcodeExpire = date
        },
        getUuid() {
            return uuidv1().replace(/-/g, '')
        },
        getFileUrl(fileType) {
            let time = dayjs(new Date()).format('YYYY-MM')
            return `qyweixin/group/qrcode/${time}/${this.getUuid()}.${fileType}`
        },
        uploadFile(e) {
            this.loading = true;
            let self = this
            let file = e.file
            let fileName = file && file.name ? file.name.split('.') : ['jpg']
            let storeAs = this.getFileUrl(fileName[fileName.length - 1])
            let client = new OSS({
                accessKeyId: self.ossToken.accessKeyId,
                accessKeySecret: self.ossToken.accessKeySecret,
                stsToken: self.ossToken.securityToken,
                bucket: 'after-class',
                region: 'oss-cn-hangzhou',
            })
            client.multipartUpload(storeAs, file, {
                parallel: 4,
                partSize: 1024 * 1024,
                progress: self.pace,
            }).then(function (result) {
                let url = window.globalConfig.fileUrl + result.name
                self.imageUrl = url
                user.log({ type: 'upload', file: url })
            }).catch(function (err) {
                self.$message.error(
                    '文件上传失败:"' + err.message + '" 请重新尝试上传。'
                )
            }).finally(() => {
                this.loading = false;
            })
        },
        beforeUpload(file) {
            const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
            if (!isJpgOrPng) {
                this.$message.error('请上传JPG或PNG格式的图片');
            }
            const isLt2M = file.size / 1024 / 1024 < 2;
            if (!isLt2M) {
                this.$message.error('图片不能超过2M');
            }
            return isJpgOrPng && isLt2M;
        },
        saveQrcode() {
            if (!this.imageUrl) return this.$message.error('请上传二维码');
            if (!this.qrcodeExpire) return this.$message.error('请选择有效期');
            if (dayjs(this.qrcodeExpire).format('YYYY-MM-DD') == dayjs().format('YYYY-MM-DD')) return this.$message.warn('二维码有效期太短');
            let params = {
                chatId: this.groupId,
                qrcode: this.imageUrl,
                qrcodeExpire: this.qrcodeExpire
            }
            qywx.saveQrcode(params).then(res => {
                this.getGroupInfo()
            }).catch(err => {
                this.$message.error(err.msg)
            })
        },
        reUpload() {
            this.getGroupInfo(true)
        },
        // 打开群聊
        openGroup() {
            ww.openEnterpriseChat({
                chatId: this.targetGroupId,
                success: (res) => {
                    this.output(res, '打开群聊')
                },
                fail: (err) => {
                    this.output(err, '打开群聊失败');
                }
            })
        },
        // 分享链接
        messageTest() {
            if (!this.targetGroupId) return this.$message.error('请先输入群聊ID')
            this.output(this.targetGroupId, '分享链接至该群')
            const time = " " + dayjs().format("HH:mm");
            const title = this.shareTitle + time
            const xhr = new XMLHttpRequest();
            xhr.open("GET", "https://beta-operation-api.khsdb.com:8443/qyweixin/clickSend?title=" + encodeURIComponent(title), true);
            xhr.onload = () => {
                // this.output("xhr.onload");
            };
            xhr.onreadystatechange = () => {
                if (xhr.readyState === XMLHttpRequest.DONE) {
                    if (xhr.status === 200) {
                        this.output(xhr.responseText, this.targetGroupId + '调用clickSend接口');
                    } else {
                        this.output(xhr.status, this.targetGroupId + '调用clickSend接口失败，状态码为');
                    }
                }
            };
            xhr.onerror = (err) => {
                this.output(err, this.targetGroupId + '调用clickSend接口失败');
            };
            xhr.ontimeout = () => {
                this.output(xhr.status, this.targetGroupId + '调用clickSend接口超时，状态码为');
            };
            xhr.send(null);
            ww.openExistedChatWithMsg({
                chatId: this.targetGroupId,
                msg: {
                    msgtype: 'link',
                    link: {
                        title: title,
                        desc: this.shareDesc,
                        url: this.shareUrl,
                        imgUrl: 'https://khsdb.com/icon/green-dot.png'
                    }
                },
                success: (res) => {
                    this.output(res, '分享链接成功')
                },
                fail: (err) => {
                    this.output(err, '分享链接失败');
                },
                cancel: () => {
                    this.output('取消分享链接');
                },
            })
        },
        initWebSocket() {
            // 连接WebSocket并设置消息处理
            websocketService.connect((message) => {
                // 在这里执行你的操作
                // console.log('收到webSocket', message.body)
                this.output(message.body,'收到webSocket')
                // 创建一个队列，递归执行更新二维码
                try {
                    const data = JSON.parse(message.body).data
                    this.wsList.push(data)
                    this.handleWsList()
                } catch (err) {
                    this.output(err, 'webSocket处理失败');
                }
            })
        },
        handleWsList() {
            // 当有推送或者定时更新的时候，等前面的执行完再继续
            if (this.updateingFlag || this.pollingFlag) return
            // console.log('当前webSocket处理队列', this.wsList)
            this.output(this.wsList, '实时更新队列')
            this.processHandleWsList()
        },
        // 递归执行更新实时二维码
        processHandleWsList() {
            // 如果正在处理中，或者队列为空，则返回
            if (this.isProcessing || this.wsList.length === 0) {
                return
            }
            this.isProcessing = true
            const item = this.wsList.shift()
            this.output(this.wsList.length, '剩余队列长度')
            this.handleUpdate(item, () => {
                this.isProcessing = false
                this.processHandleWsList()
            })
        },
        checkBothFalse() {
            if (!this.updateingFlag && !this.pollingFlag && this.wsList.length > 0) {
                this.handleWsList()
            }
        },
        sendRequest() {
            // 手动发送请求
            websocketService.sendMessage("/app/request-stats", {})
        }
    },
};
</script>

<style lang="less" scoped>
.page {
    margin: 0;
    min-height: 100vh;
    min-width: 343px;
    font-family: Arial, sans-serif;
    background-color: #fff;
}

.df {
    display: flex;
    align-items: center;
}

.jcsb {
    justify-content: space-between;
}

.mt-8 {
    margin-top: 8px;
}

.mt-8 {
    margin-top: 8px;
}

.mb-12 {
    margin-bottom: 12px;
}

.mb-10 {
    margin-bottom: 10px;
}

.red {
    color: #FF0000;
}

.dfsb {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.step {
    .class {
        background-color: #ebf8ff;
        padding: 16px;
        color: #595959;
        padding-bottom: 12px;
    }

    .step-box {
        padding: 18px 24px 18px 16px;

        .step-title {
            font-size: 16px;
            margin-bottom: 16px;
        }
    }

    .suggestion {
        margin-bottom: 26px;
        position: relative;

        .line::before {
            content: '';
            position: absolute;
            left: 4px;
            top: 28px;
            width: 0;
            height: 0;
            border-top: 15px solid #0089ff;
            border-left: 13px solid transparent;
            border-right: 13px solid transparent;
            border-bottom: 0 solid transparent;
            z-index: 1;
        }
    }

    .round {
        text-align: center;
        line-height: 26px;
        width: 34px;
        height: 34px;
        border-radius: 50%;
        border: 4px solid #0089FF;
        margin-right: 16px;
        font-size: 18px;
        color: #0089FF;
        background-color: #fff;
        z-index: 2;
    }

    .title {
        font-size: 16px;
        font-weight: bold;
        color: #0089FF;
    }

    .pic {
        padding-left: 48px;

        img {
            max-width: 316px;
            min-width: 200px;
            width: calc(100vw - 165px);
            border-radius: 10px;
        }
    }

    .upload {
        padding-left: 48px;

        a {
            text-decoration: underline;
        }
    }

    .qrcode {
        min-width: 200px;
        max-width: 316px;
        width: calc(100vw - 185px);
        box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.06);
        border-radius: 10px;
        padding: 10px;

        img {
            max-width: 296px;
            min-width: 180px;
            width: calc(100vw - 205px);
        }
    }

    .btn {
        margin-top: 8px;

        button {
            border-color: #0089FF;
            color: #0089FF;
            max-width: 316px;
            width: calc(100vw - 185px);
            min-width: 200px;
        }
    }
}


.log-box {
    margin-top: 10px;
    min-height: 400px;
    border-radius: 4px;
    border: solid 1px #d9d9d9;
    padding: 4px;
    width: 100%;
}

.box {
    background-color: #fff;
    padding: 12px 16px;
    border-radius: 8px;

    .label {
        width: 100px;
    }
}

.group-id {
    border-radius: 4px;
    border: 1px solid #d9d9d9;
    height: 32px;
    line-height: 30px;
    padding: 0 11px;
    margin-bottom: 12px;
}

.grey-text {
    color: #ADA8A8;
}

.push-status {
    font-size: 20px;
    line-height: 32px;
    display: flex;
    align-items: center;

    .w100 {
        width: 100px;
    }

    .btn {
        display: flex;
        margin-left: 30px;
        height: 32px;
    }
}

.green {
    color: #2DB300;
}

.count-box {
    padding-left: 16px;
    font-size: 16px;
}

.date-text {
    margin-top: 10px;
    text-align: center;
    max-width: 316px;
    width: calc(100vw - 185px);
    min-width: 200px;
}

.uploader {
    margin-top: 10px;

    ::v-deep .ant-upload {
        width: 200px !important;
        height: 200px !important;

        img {

            width: 200px !important;
            height: 200px !important;
        }
    }
}

.ant-upload-select-picture-card i {
    font-size: 36px;
    color: #999;
}

.ant-upload-select-picture-card .ant-upload-text {
    margin-top: 8px;
    font-size: 16px;
    color: #666;
}

::v-deep .ant-upload-list-picture-card-container {
    display: none;
}
</style>